var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgerMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.21517,0,0,0.195402,-4.95983,4.04277)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.155,
    y: 3.907,
    width: 6.233,
    height: 16.186
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.21517,0,0,0.195402,-4.95983,9.60478)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.155,
    y: 3.907,
    width: 6.233,
    height: 16.186
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.21517,0,0,0.195402,-4.95983,15.1668)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.155,
    y: 3.907,
    width: 6.233,
    height: 16.186
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenu);
export default __webpack_public_path__ + "static/media/burger-menu.3d345e46.svg";
export { ForwardRef as ReactComponent };